module.exports = __webpack_public_path__ + "static/ParasD-ba3d1e3c84e358715fb27d983611cb41.jpg";